var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('banner',{attrs:{"color-scheme":"secondary","banner-message":_vm.bannerMessage,"action-button-label":_vm.actionButtonMessage},on:{"click":_vm.routeToBilling}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }